<template lang="pug">
include /mixins
+b.result-img-loader-wrapper(
  @dragover.prevent="handleDragOver"
  @drop.prevent="handleDrop"
  @dragenter.prevent
  @dragleave="handleDragLeave"
)
  +e.heading(v-if="titles && titles.initial")
    +e.P.title {{ titles.initial }}
  input(type='file' :accept="acceptedFiles" :id='name' @input='handleDrop')
  +b.result-img-loader(
    :class="{ 'is-active': localImage, 'is-horizontal': orientation === 'horizontal', 'is-vertical': orientation === 'vertical', 'is-simple': simpleView }"
  )
    +e.img.IMG(
      :src='localImage',
      v-if='localImage'
    )
    +e.LABEL.content(
      v-else
      :for="name"
    )
      +e.icon
        svg(width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg")
          path(d="M14.9995 2.00098H5.5C4.67157 2.00098 4 2.67255 4 3.50098V20.501C4 21.3294 4.67157 22.001 5.5 22.001H18.5C19.3284 22.001 20 21.3294 20 20.501V7.5M14.9995 2.00098V6C14.9995 6.82843 15.6711 7.5 16.4995 7.5L20 7.5M14.9995 2.00098L20 7.5" stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round")
      +e.main
        +e.heading.--variant_desktop
          +e.P.title {{ _("Перетащите сюда файл") }}
          +e.P.title.--variant_1 {{ _("или выберите его") }}
        +e.heading.--variant_mobile
          +e.P.title.--variant_1 {{ _("Загрузите файл") }}
        +e.formats.P {{ formatsHint }}
  +e.footer
    +b.tt-button.--bordered_main.LABEL(
      :for="name"
    )
      +e.title.SPAN {{ localImage ? titles.update : titles.create }}
</template>

<script>
import Clipper from '@app/Staff/Components/Clipper'

const DEFAULT_SIZE = 200
const DEFAULT_RATIO = 1

export default {
  name: 'ResultLoader',
  props: {
    name: {},
    titles: {},
    uploadedFile: {},
    acceptedType: {
      type: String,
    },
    type: {
      default: () => 'avatar',
    },
    width: {
      default: () => DEFAULT_SIZE,
    },
    height: {
      default: () => DEFAULT_SIZE,
    },
    method: {
      default: () => 'POST',
    },
    ratio: {
      default: () => DEFAULT_RATIO,
    },
    rate: {
      default: () => DEFAULT_RATIO,
    },
    postResource: {},
    additional: {},
    filekey: {
      default: 'img',
    },
    orientation: {
      type: String,
    },
    simpleView: {
      type: Boolean,
      default: false,
    },
    needCrop: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      file: null,
      localImage: this.uploadedFile || null,
      isDragOver: false,
    }
  },
  computed: {
    acceptedFiles() {
      if ('image_pdf_doc' === this.acceptedType) {
        const formats = [
          'image/*',
          'application/pdf',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        ]
        return formats.join(',')
      }

      return 'image/*'
    },
    formatsHint() {
      if ('image_pdf_doc' === this.acceptedType) {
        return this._('.jpg. .png .docx .pdf')
      }

      return this._('.jpg. .png')
    },
  },
  methods: {
    handleDragOver(event) {
      event.preventDefault();
      this.isDragOver = true;
      // Добавим следующую строку, чтобы предотвратить открытие изображения в новой вкладке
      event.dataTransfer.dropEffect = 'copy';
    },
    handleDragLeave() {
      this.isDragOver = false;
    },
    handleDrop(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      this.toggleShow(files[0])
    },
    toPromise(file) {
      if (!file) return Promise.reject()

      return Promise.resolve({
        file, img: window.URL.createObjectURL(file),
      })
    },
    load(element) {
      if (this.postResource) {
        this.postResource.execute({}, {
          ...this.additional, [this.filekey]: element,
        }).then(({ data: { item: { id } } }) => {
          this.$emit('update', id)
        })
      }
    },
    toggleShow(imgfile) {
      const preview = window.URL.createObjectURL(imgfile)

      if (!this.needCrop) {
        this.load(imgfile)

        // const blob = new Blob([imgfile], { type: 'image/png' })

        this.localImage = preview

        this.$emit('image', preview)

        return
      }

      const pr = f => this.toPromise(f)
        .then(({ file, img }) => {
          this.file = file
          this.localImage = img
          this.load(file)
          this.$emit('completed', { key: 'img', value: file })
          this.$emit('image', img)
        })
        .catch(err => {
          this.$emit('error', err)
        })

      this.$modal.show(
        Clipper,
        {
          promise: pr,
          type: this.type,
          w: this.width,
          h: this.height,
          method: this.method,
          ratio: this.ratio,
          rate: this.rate,
          orientation: this.orientation,
          preview,
        },
        {
          height: 'auto',
          classes: 'loadPopup',
          adaptive: true,
          scrollable: true,
        }
      )
    },
  },
}
</script>
